import { Link } from "react-router-dom";
import { metaFor } from "../../shared/seo";
import { useMeta } from "../lib/seo";
import { origin } from "../lib/origin";

export function NotFound() {
  useMeta(metaFor({ route: "notfound", base: origin() }));
  return (
    <div className="empty-state pad-empty-lg">
      <h1>404</h1>
      <p>That page doesn't exist.</p>
      <Link to="/" className="btn btn-primary">Go home</Link>
    </div>
  );
}

export function Login() {
  useMeta(metaFor({ route: "notfound", base: origin() }));
  return (
    <div className="empty-state pad-empty">
      <h1>Sign in</h1>
      <p>Use the “Sign in” button in the header. Production auth is handled by SSOJet.</p>
      <Link to="/" className="btn btn-ghost">Back home</Link>
    </div>
  );
}
